import React, { useEffect, useState } from "react";
import PlanCards from "./PlanCards";

function PricingPage() {
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);

  useEffect(() => {
    const loadRazorpayScript = () => {
      return new Promise((resolve, reject) => {
        if (document.getElementById("razorpay-script")) {
          resolve(true); // Already loaded
          return;
        }

        const script = document.createElement("script");
        script.id = "razorpay-script";
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => resolve(true);
        script.onerror = () => reject("Razorpay SDK failed to load.");
        document.body.appendChild(script);
      });
    };

    loadRazorpayScript()
      .then(() => {
        console.log("Razorpay script loaded.");
        setRazorpayLoaded(true);
      })
      .catch((err) => {
        console.error("Failed to load Razorpay script:", err);
        setRazorpayLoaded(false);
      });
  }, []);

  return (
    <div className="flex-1 bg-gray-50">
      <PlanCards />
    </div>
  );
}

export default PricingPage;
